import React from 'react';

const ImageResultCard = ({
  isBatchMode,
  batchResult,
  renderedPreviewUrl,
  outputInfo,
  truncateTwoWords,
  canDownloadResult,
  onDownload,
  onToggleComparison,
  includeAiMetadata,
  onToggleAiMetadata,
  aiMetadataAvailable,
}) => {
  return (
    <section className="inspector-card result-card">
      <div className="inspector-card-title">Result</div>
      {isBatchMode && batchResult ? (
        <div className="batch-result-summary">
          <div className="result-copy">
            {batchResult.summary
              ? `${batchResult.summary.succeeded} succeeded, ${batchResult.summary.failed} failed`
              : 'Batch results ready'}
          </div>
          {batchResult.archiveFilename && (
            <div className="batch-archive-chip">
              ZIP: {batchResult.archiveFilename}
            </div>
          )}
          <div className="batch-result-list">
            {batchResult.results?.map((item) => (
              <div key={`${item.fileId}-${item.fileName}`} className={`batch-result-item ${item.success ? 'success' : 'failed'}`}>
                <div className="batch-result-file">
                  <strong>{truncateTwoWords(item.fileName)}</strong>
                  <span>{item.success ? item.filename : item.error}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <>
          <div className="result-copy">{outputInfo}</div>
          {renderedPreviewUrl && (
            <div className="result-preview">
              <img src={renderedPreviewUrl} alt="Rendered output preview" />
            </div>
          )}
        </>
      )}

      {/* Render result control actions dynamically when download results are available */}
      {canDownloadResult && (
        <div className="result-actions-section mt-4 pt-4 border-t border-white/10">
          {aiMetadataAvailable && (
            <div className="ai-download-option mb-3">
              <label className="checkbox-container">
                <input 
                  type="checkbox" 
                  checked={includeAiMetadata} 
                  onChange={onToggleAiMetadata}
                />
                <span className="checkbox-checkmark"></span>
                <span className="checkbox-label" style={{ fontSize: '11px', color: 'var(--studio-text-muted)' }}>Include AI Metadata (ALT, Caption)</span>
              </label>
            </div>
          )}

          <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
            <button
              className="compare-btn"
              style={{ flex: 1, margin: 0, minHeight: '36px' }}
              type="button"
              onClick={onToggleComparison}
              disabled={!canDownloadResult}
              title="Compare original vs edited (Backslash key)"
            >
              <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>compare</span>
              <span style={{ fontSize: '12px' }}>{canDownloadResult ? 'Compare' : 'Before/After'}</span>
            </button>

            <button
              className="download-cta"
              style={{ flex: 1, margin: 0, minHeight: '36px' }}
              type="button"
              onClick={onDownload}
              disabled={!canDownloadResult}
            >
              <span style={{ fontSize: '12px' }}>
                {canDownloadResult
                  ? (isBatchMode ? 'ZIP' : 'Download')
                  : 'No Result'}
              </span>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ImageResultCard;
